import { Image } from '@chakra-ui/react';
import React from 'react';

import NotificationIcon from '../../../../assets/icons/icon_notification.svg';
import {
    Notification,
    NotificationsCount
} from './notifications.styled';
import { NotificationType } from './notifications.types';

type NotificationsProps = {
notifications: NotificationType[]
};

export const Notifications = ({ notifications }: NotificationsProps) => {
    const hasNotifications = notifications.length !== 0;

    return (
        <Notification>
            <Image src={NotificationIcon} w={'24px'} />
            {hasNotifications && (
                <NotificationsCount
                    data-testid={'notification-count'}
                >
                    {notifications.length}
                </NotificationsCount>
            )}
        </Notification>
    );
};
